import React, { PropsWithChildren, ReactElement } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { PriceCardSectionProps } from "./price-card-section.tsx";
import { useIsInsideCardStack } from "./price-cards-stack.tsx";

export interface PriceCardProps extends PropsWithChildren {
    first?: boolean;
    last?: boolean;
    outlined?: boolean;
}

export const PriceCard = (props: PriceCardProps) => {
    const { isInsideCardStack } = useIsInsideCardStack();

    const validChildren: ReactElement[] = [];
    React.Children.forEach(props.children, (child) => {
        if (React.isValidElement(child)) {
            validChildren.push(child);
        }
    });
    const children = validChildren.map((child, index) => {
        return React.cloneElement(
            child as ReactElement<PriceCardSectionProps>,
            {
                key: index,
                first: index === 0,
                last: index === React.Children.count(validChildren) - 1,
                firstCard: props.first,
                lastCard: props.last,
                outlined: props.outlined
            }
        );
    });

    if (isInsideCardStack) {
        return children;
    }

    return <div css={priceCardCss}>{children}</div>;
};

const priceCardCss = css({
    [media.below.md]: {
        width: "100%"
    }
});

export const getPriceCardProps = ({
    first,
    last,
    outlined
}: PriceCardProps): PriceCardProps => ({ first, last, outlined });
